import React, { useState, useEffect } from 'react';
import { Product } from '../App';

export default function ClassPage({ onProductClick, products, categories, merchants, t }: { onProductClick: (p: Product) => void; products: Product[]; categories: {name: string; icon: string}[]; merchants: any[]; t: (key: string) => string }) {
  const [activeCat, setActiveCat] = useState(categories.length > 0 ? categories[0].name : '');
  const [activeMerchant, setActiveMerchant] = useState<string>('');
  
  // 当分类切换时，重置商家筛选
  useEffect(() => {
    setActiveMerchant('');
  }, [activeCat]);

  const filtered = products.filter(p => {
    if (p.category !== activeCat) return false;
    if (activeMerchant && String(p.merchant_id) !== activeMerchant) return false;
    return true;
  });

  // 获取当前分类下的商家列表
  const categoryMerchants = merchants.filter((m: any) => {
    return products.some((p: any) => p.category === activeCat && String(p.merchant_id) === String(m.id));
  });

  return (
    <div>
      <div className="search-bar">
        <input className="search-input" placeholder={"🔍 " + t('search')} />
      </div>
      <div className="class-page">
        <div className="class-sidebar">
          {categories.map(cat => (
            <div
              key={cat.name}
              className={`class-sidebar-item ${activeCat === cat.name ? 'active' : ''}`}
              onClick={() => setActiveCat(cat.name)}
            >
              {cat.icon} {cat.name}
            </div>
          ))}
        </div>
        <div className="class-products">
          <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'12px'}}>
            <div className="class-products-title">{activeCat}</div>
            {categoryMerchants.length > 0 && (
              <select 
                value={activeMerchant} 
                onChange={(e) => setActiveMerchant(e.target.value)}
                style={{padding:'6px 12px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'13px', outline:'none'}}
              >
                <option value="">全部商家</option>
                {categoryMerchants.map((m: any) => (
                  <option key={m.id} value={String(m.id)}>{m.name}</option>
                ))}
              </select>
            )}
          </div>
          {filtered.length === 0 ? (
            <div style={{textAlign:'center',color:'#999',padding:40}}>{t('noResults')}</div>
          ) : (
            <div className="product-grid">
              {filtered.map(p => (
                <div className="product-card" key={p.id} onClick={() => onProductClick(p)}>
                  <img src={p.image} alt={p.name} onError={(e: any) => e.target.src='data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 180"><rect fill="%23f0f0f0" width="200" height="180"/><text x="100" y="95" text-anchor="middle" fill="%23ccc" font-size="14">No Image</text></svg>'} />
                  <div className="product-card-info">
                    <div className="product-card-name">{p.name}</div>
                    <div className="product-card-prices">
                      <span className="pi-price">{p.piPrice}</span>
                      <span className="original-price">¥{p.originalPrice}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
